<template>
    <div class="grid font-['Inter']">
        <!-- <label class="text-sm pb-2" :for="name">{{label}}<span v-if="required" class="text-red-600">*</span></label> -->
        <div id="otp" class="d-flex"> 
            <input class="text-center form-control rounded m-1 accred-form-control ap-otp-input" @paste="onPaste()" @keyup="updateValue($event,1)" @focus="onFocusEvent(1)" type="text" id="otp_1" maxlength="1" ref="first"/>         
            <input class="text-center form-control rounded m-1 accred-form-control ap-otp-input"  @keyup="updateValue($event,2)" @focus="onFocusEvent(2)" type="text" id="otp_2" maxlength="1" ref="second" />        
            <input class="text-center form-control rounded m-1 accred-form-control ap-otp-input"  @keyup="updateValue($event,3)" @focus="onFocusEvent(3)" type="text" id="otp_3" maxlength="1" ref="third" />        
            <input class="text-center form-control rounded m-1 accred-form-control ap-otp-input"  @keyup="updateValue($event,4)" @focus="onFocusEvent(4)" type="text" id="otp_4" maxlength="1" ref="fourth" />       
            <input class="text-center form-control rounded m-1 accred-form-control ap-otp-input"  @keyup="updateValue($event,5)" @focus="onFocusEvent(5)" type="text" id="otp_5" maxlength="1" ref="fifth" />    
            <input class="text-center form-control rounded m-1 accred-form-control ap-otp-input"  @keyup="updateValue($event,6)" @focus="onFocusEvent(6)" type="text" id="otp_6" maxlength="1" ref="sixth" /> 
        </div>
    </div>
</template>

<script>
    export default {
        name: 'textbox',
        props: ['value', 'label', 'name', 'required'],
        data () {
            return {
                otp: ''
            }
        },
        mounted: function () {
            this.OTPInput();
            this.focusInput();
        },
        methods: {
            onPaste() {
                alert('Text Pasted');
            },
            focusInput() {
                this.$refs.first.focus();
            },
            getOtpElement(index) {
                return document.getElementById('otp_' + index);
            },
            onFocusEvent(index) {
                var item;
                for (item = 1; item < index; item++) {
                const currentElement = this.getOtpElement(item);
                    if (!currentElement.value) {
                        currentElement.focus();
                        break;
                    }
                }
            },
            updateValue: function (event,index) {
                const eventCode = event.which || event.keyCode;
                if (this.getOtpElement(index).value.length === 1) {
                    if (index !== 6) {
                        this.getOtpElement(index+ 1).focus();
                    } else {
                        this.getOtpElement(index).blur();
                    }
                }
                if (eventCode === 8 && index !== 1) {
                    this.getOtpElement(index - 1).focus();
                }
                var value = this.$refs.first.value + this.$refs.second.value + this.$refs.third.value + this.$refs.fourth.value  + this.$refs.fifth.value + this.$refs.sixth.value;
                this.$emit('input', value);
            },
            OTPInput:function () {
                const inputs = document.querySelectorAll('#otp > *[id]');
                for (let i = 0; i < inputs.length; i++) { 
                    inputs[i].addEventListener('keydown', function(event) { 
                        if (event.key==="Backspace" ) { 
                            inputs[i].value='' ; 
                            if (i !==0) inputs[i - 1].focus(); 
                        } else { 
                            if (i===inputs.length - 1 && inputs[i].value !=='' ) { 
                                return true; 
                            } else if (event.keyCode> 47 && event.keyCode < 58) { 
                                inputs[i].value=event.key; 
                                if (i !==inputs.length - 1) inputs[i + 1].focus(); 
                                event.preventDefault(); 
                            } else if (event.keyCode> 64 && event.keyCode < 91) { 
                                inputs[i].value=String.fromCharCode(event.keyCode); 
                                if (i !==inputs.length - 1) inputs[i + 1].focus(); 
                                event.preventDefault(); 
                            } 
                        } 
                    }); 
                }
                
            }
        }
    }
</script>